// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__1Vrql","frame":"Dialog_frame__2TKNR","closeButton":"Dialog_closeButton__2qGLn","okButton":"Dialog_okButton__152Qn","body":"Dialog_body__16Psn"};